// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3ihzj","file":"styles_file__3sD1v"};